import { makeStyles } from "@mui/styles";

const servicetStyle = makeStyles((theme) => ({
  boldText: {
    fontWeight: "600 !important",
    fontSize: "2rem !important",
  },
  hrLine: {
    height: "3px",
    width: "60px",
    backgroundColor: "#008374",
    margin: "0px auto",
  },
}));

export default servicetStyle;
